import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2f029f00&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2f029f00&scoped=true&lang=less&"
import style1 from "./index.vue?vue&type=style&index=1&id=2f029f00&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f029f00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/BgUizHzZB/0/snt/info/info-customer/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f029f00')) {
      api.createRecord('2f029f00', component.options)
    } else {
      api.reload('2f029f00', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2f029f00&scoped=true&", function () {
      api.rerender('2f029f00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Header/index.vue"
export default component.exports